module.exports = __webpack_public_path__ + "img/71.062d6cdb.png";